var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rechteck_477","data-name":"Rechteck 477","width":"28","height":"28","fill":"none","key":0}),React.createElement("path",{"id":"Polygon_19","data-name":"Polygon 19","d":"M14,0,28,24H0Z","transform":"translate(28) rotate(90)","fill":"#1d1d1b","key":1})]);
}

PlayInline.defaultProps = {"id":"Play","width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
